export default "__VITE_ASSET__86816cb0__"